import type { RecordLike } from '../types';

/**
 * Checks if value is a plain object (not null, array, or other types)
 */
export const isRecordLike = (value: unknown): value is RecordLike => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
